import React from "react";
import { PWG_LINE_TYPES, customerLineTypeLabel, lineTypeTone } from "./lineType";

export default function LineTypeControls({ selectedTypes = ["regular"], availableTypes = [], onSelect, darkMode = false, className = "", style = {} }) {
  const selected = new Set(selectedTypes);
  const available = new Set(availableTypes);
  return (
    <div className={className} aria-label="PrizePicks line type filters" style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", ...style }}>
      <span style={{ fontSize: 12, fontWeight: 850, color: darkMode ? "#CBD5E1" : "#475569", alignSelf: "center" }}>Line type</span>
      <button
        type="button"
        aria-pressed={selected.has("all")}
        onClick={() => onSelect?.(["all"])}
        style={{ padding: "4px 9px", borderRadius: 999, border: "1px solid #94A3B8", background: selected.has("all") ? "#F1F5F9" : "transparent", color: darkMode ? "#E2E8F0" : "#334155", fontSize: 11, fontWeight: 900, cursor: "pointer" }}
      >
        ALL
      </button>
      {PWG_LINE_TYPES.map((type) => {
        const active = selected.has("all") || selected.has(type);
        const enabled = available.has(type);
        const tone = lineTypeTone(type);
        return (
          <button
            key={type}
            type="button"
            aria-pressed={selected.has(type)}
            disabled={!enabled}
            onClick={() => onSelect?.([type])}
            style={{ padding: "4px 9px", borderRadius: 999, border: `1px solid ${tone.border}`, background: tone.background, color: tone.color, fontSize: 11, fontWeight: 900, opacity: enabled ? (active ? 1 : 0.42) : 0.25, cursor: enabled ? "pointer" : "not-allowed" }}
          >
            {customerLineTypeLabel(type)}
          </button>
        );
      })}
    </div>
  );
}
